import React, { useMemo } from 'react';
import Card from '../../../../componentes/contenedores/Card';
import Page from '../../../../componentes/plantilla/Page';
import { useContextEmpleado } from "../../../../contexto/empleado/EmpleadoContext";
import ModalInventarioTipo from './ModalInventarioTipo';
import Tablas from "../../../../componentes/tablas/TablasGenerico";
import EliminarInventarioTipo from './EliminarInventarioTipo';
import { createRoot } from 'react-dom/client';

const HomeInventarioTipo = () => {
    const { listaInventariosTipos, setListaInventariosTipos, ActualizarLista, token } = useContextEmpleado();

    const datos = {
        titulo: {
            titulo: "Nuevo tipo de inventario",
            url: "/app/admin/inventarios/tipos",
            tituloUrl: "inventario",
            nombreUrl: "tipos"
        }
    }

    const columnasInventarioTipo = useMemo(
        () => [
            { targets: 0, title: "Id", data: "id" },
            { targets: 1, title: "Nombre", data: "nombre" },
            { targets: 2, title: "Tipo", data: "tipo" },
            {
                targets: 3,
                title: "Estado",
                data: "estado",
                render: (data) => {
                    return `<span class="badge ${data === "Activo" ? "badge-success" : "badge-danger"}">${data}</span>`;
                }
            },
            {
                targets: 4,
                title: "Opciones",
                data: null,
                orderable: false,
                searchable: false,
                className: 'dt-center all',
                createdCell: (td, cellData, rowData) => {
                    const root = createRoot(td);
                    root.render(
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "1em" }}>
                            <ModalInventarioTipo
                                datos={rowData}
                                token={token}
                                setListaInventariosTipos={setListaInventariosTipos}
                                ActualizarLista={ActualizarLista}
                            />
                            <EliminarInventarioTipo
                                datos={rowData}
                                token={token}
                                setListaInventariosTipos={setListaInventariosTipos}
                                ActualizarLista={ActualizarLista}
                            />
                        </div>
                    );
                },
            },
        ],
        [token, setListaInventariosTipos, ActualizarLista]
    );


    return (
        <Page datos={datos}>
            <Card
                titulo="Módulo de gestión de tipos de inventario"
                pie={<ModalInventarioTipo token={token} setListaInventariosTipos={setListaInventariosTipos} ActualizarLista={ActualizarLista} />}
            >
                <div>
                    <p className="card-text">
                        Este módulo ayuda en la organización y administración de los diferentes tipos de inventario, como bodegas o inventarios móviles.
                    </p>
                </div>
            </Card>
            <Card titulo="Lista de tipos de inventario">
                <Tablas
                    datos={listaInventariosTipos}
                    columnas={columnasInventarioTipo}
                    id="tablaInventarioTipos"
                />
            </Card>
        </Page>
    )
}

export default HomeInventarioTipo;